import { Seeder } from '../seeder'
import { bsConstants } from '../../module.constants'
import { LiveSeedArcTeams, SeedArcTeam, SeedArcTeams } from './interfaces'
import { UserSeeder } from '../user'

const userSeeder = new UserSeeder()
const seedUsers = { ...userSeeder.getLiveDataObject(), ...userSeeder.getTestDataObject() }

export class ArcTeamSeeder extends Seeder<SeedArcTeams, {}, SeedArcTeam> {
  type = 'arcTeam'
  maxModelCount = 40

  getLiveDataObject (): LiveSeedArcTeams {
    return {
      DeletedTeam: {
        id: 1,
        name: '[Deleted Team]',
        image: '',
        description: 'Deleted Team Placeholder',
        userId: seedUsers.DeletedUser.id
      }
    }
  }

  getTestDataObject (): SeedArcTeams {
    if (process.env.BUILD_MODE === 'master') {
      return {} as unknown as SeedArcTeams
    }

    const seedUsers = new UserSeeder().getTestDataObject()

    const testData = {
      TimothyZahnFans: {
        id: this.getNextId(),
        name: 'Timothy Zahn Fans',
        image: 'TimothyZahn.jpg',
        description: 'A team for all those wanting to get ARCs for Timothy Zahn\'s latest and greatest!',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.HanSolo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.REJECTED,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.LukeSkywalker.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.BLOCKED,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.MaraJade.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.Thrawn.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.VIP
          },
          {
            userId: seedUsers.ApproveUser.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.RejectUser.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      DrewKarpyshynFans: {
        id: this.getNextId(),
        name: 'Drew Karpyshyn Fans',
        image: 'DrewKarpyshyn.jpg',
        description: 'A team for all those wanting to get ARCs for Drew Karpyshyn\'s mostly latest and mostly greatest!',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Publisher.id,
        members: [
          {
            userId: seedUsers.Publisher.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.HanSolo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.LukeSkywalker.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      TeamForTheDarkSide: {
        id: this.getNextId(),
        name: 'Join the Darkside',
        image: 'DarkSide.jpg',
        description: 'Note: 2 people max! The rule of 2 still applies! Books for all dark side fans!',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.Thrawn.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.DarthVadar.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      TeamForTheLightSide: {
        id: this.getNextId(),
        name: 'Become one with the force',
        image: 'LightSide.jpg',
        description: 'Books for all lightside fans!',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.MaraJade.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.LukeSkywalker.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.VIP
          },
          {
            userId: seedUsers.HanSolo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.Publisher.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      NoMemberTeam: {
        id: this.getNextId(),
        name: 'Team No Mates',
        image: 'test.png',
        description: 'No users, no image - sorry little thing ...',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id
      },
      FreeAuthorTeam: {
        id: this.getNextId(),
        name: 'Free Author Team',
        image: 'test.png',
        description: 'Free author team description',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.FreeAuthor.id
      },
      GrowingAuthorTeam: {
        id: this.getNextId(),
        name: 'Growing Author Team',
        image: 'test.png',
        description: 'Growing author team description',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.GrowingAuthor.id
      },
      ProAuthorTeam: {
        id: this.getNextId(),
        name: 'Pro Author Team',
        image: 'test.png',
        description: 'Pro author team description',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.ProAuthor.id
      },
      BestSellerAuthorTeam: {
        id: this.getNextId(),
        name: 'BestSeller Author Team',
        image: 'test.png',
        description: 'BestSeller author team description',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.BestsellingAuthor.id
      },
      PublisherTeam: {
        id: this.getNextId(),
        name: 'Publisher Author Team',
        image: 'test.png',
        description: 'Publisher author team description',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Publisher.id
      },
      ReviewDueSoonTeam: {
        id: this.getNextId(),
        name: 'Review Due Soon Team',
        image: 'test.png',
        description: 'Review due soon team!',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Publisher.id,
        members: [
          {
            userId: seedUsers.HasReviewDueSoon.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      PlaceholderTeamOne: {
        id: this.getNextId(),
        name: 'Placeholder Team One',
        image: 'test.png',
        description: 'Team which can be used for testing applicants',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      PlaceholderTeamTwo: {
        id: this.getNextId(),
        name: 'Placeholder Team Two',
        image: 'test.png',
        description: 'Team which can be used for testing applicants',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.AWAITING,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      StanBlocked: {
        id: this.getNextId(),
        name: 'Stan Blocked',
        image: 'test.png',
        description: 'Stan is blocked from this team',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.BLOCKED,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR,
            statusReason: 'Something',
            statusReasonType: bsConstants.ARC_TEAMS.MEMBERS.STATUS_REASON_TYPE.HARASSMENT
          },
          {
            userId: seedUsers.YourArcs.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.BadBoy.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.BLOCKED,
            statusReason: '',
            statusReasonType: bsConstants.ARC_TEAMS.MEMBERS.STATUS_REASON_TYPE.GENERIC,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR,
            report: true
          }
        ]
      },
      StanRegular: {
        id: this.getNextId(),
        name: 'Stan Regular',
        image: 'test.png',
        description: 'Stan is a Regular member of this team',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [
          {
            userId: seedUsers.StanRizzo.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.YourArcs.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.ClaimOutstandingTeamReviewNotVIP.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.ClaimBlockedUser.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.BLOCKED,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      TeamNotify: {
        id: this.getNextId(),
        name: 'Notifications Test Team',
        image: 'test.png',
        description: 'A team for testing all the notifications',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.NotificationAuthor.id,
        members: [
          {
            userId: seedUsers.NotificationReviewer.id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.INVITED,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.NONE
          }
        ]
      },
      OutstandingReviewTeam: {
        id: this.getNextId(),
        name: 'Outstanding Review Team',
        image: 'test.png',
        description: 'A team for testing outstanding review claims',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id
      },
      AutoAddAutoBlockTeam: {
        id: this.getNextId(),
        name: 'Auto add/block members team',
        image: 'test.png',
        description: 'A team for testing auto adding/blocking members',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        // using hardcoded email address which is used to register a user and test auto approval
        autoApproveEmailAddresses: [seedUsers.AutoApproveOnTeam.emailAddress, 'auto.approve.on.team.new.user@allangaunt.dev'],
        autoBlockEmailAddresses: [seedUsers.AutoBlockOnTeam.emailAddress]
      },
      TeamForRandomArcs: {
        id: this.getNextId(),
        name: 'Team for random arcs',
        image: 'test.png',
        description: 'A team for random arcs',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.UserForRandomArcs.id,
        members: [{
          userId: seedUsers.TopReviewerApplicationRejected.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      EbookAndAudioBook: {
        id: this.getNextId(),
        name: 'EBook and Audio book Team',
        image: 'test.png',
        description: 'Team for books running audio and ebook at same time',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.EbookAndAudioBook.id,
        members: [{
          userId: seedUsers.EbookAndAudioBookReviewer.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      ArcForSameBook: {
        id: this.getNextId(),
        name: 'Arc for same book team',
        image: 'test.png',
        description: 'Team for books running multiple arcs on it',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.ArcForSameBook.id
      },
      ArcTeamRestrictions: {
        id: this.getNextId(),
        name: 'Arc team restrictions team',
        image: 'test.png',
        description: 'A team for team restrictions',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.ArcTeamRestrictions.id,
        members: [{
          userId: seedUsers.ArcTeamRestrictionsReader.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      TooManyWithdrawals: {
        id: this.getNextId(),
        name: 'TooManyWithdrawals Arc Team',
        image: 'test.png',
        description: 'A team for TooManyWithdrawals',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.TooManyWithdrawalsAuthor.id
      },
      AmazonDelayedRequiredTeam: {
        id: this.getNextId(),
        name: 'Amazon Delayed Required Team',
        image: 'test.png',
        description: 'Team for Amazon delayed required reviews',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [{
          userId: seedUsers.YourArcs.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      AmazonDelayedMultiTeam: {
        id: this.getNextId(),
        name: 'Amazon Delayed Multi Team',
        image: 'test.png',
        description: 'Team for Amazon delayed multi-site reviews',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [{
          userId: seedUsers.YourArcs.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      AmazonRejectedRequiredTeam: {
        id: this.getNextId(),
        name: 'Amazon Rejected Required Team',
        image: 'test.png',
        description: 'Team for Amazon rejected required reviews',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [{
          userId: seedUsers.YourArcs.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      AmazonRejectedMultiTeam: {
        id: this.getNextId(),
        name: 'Amazon Rejected Multi Team',
        image: 'test.png',
        description: 'Team for Amazon rejected multi-site reviews',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id,
        members: [{
          userId: seedUsers.YourArcs.id,
          status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
          type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
        }]
      },
      ReviewTranslationTeam: {
        id: this.getNextId(),
        name: 'Review Translation Team',
        image: 'test.png',
        description: 'Team for testing non-English ARC review translations',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.ReviewTranslationAuthor.id,
        members: [
          {
            userId: seedUsers.RandomUsers[0].id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.RandomUsers[1].id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.RandomUsers[2].id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          },
          {
            userId: seedUsers.RandomUsers[3].id,
            status: bsConstants.ARC_TEAMS.MEMBERS.STATUS.ACTIVE,
            type: bsConstants.ARC_TEAMS.MEMBERS.TYPE.REGULAR
          }
        ]
      },
      // sc-26587: shared team for both saved review copies ARCs. Deliberately has NO members —
      // the ARCs are PUBLIC (discoverable + participation), so the reader can see/save/claim them
      // without joining the team. Keeping the reader off the team means they're a pure "saver" and
      // don't also receive New Arc / team notifications, which would be noise for this scenario.
      SavedArcTeam: {
        id: this.getNextId(),
        name: 'Saved-Arc Test Team',
        image: 'test.png',
        description: 'Team for the saved review copies email scenarios',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.SavedArcAuthor.id
      },
      // sc-28048: the apple-codes ARCs need a team of Me's, because their books are Me's -
      // getGeneralTestBook hardcodes that owner and an ARC whose creator is not its book's author
      // is a shape nothing else in the seed has. It cannot be an existing team of Me's either:
      // both ARCs prevent participation on an OUTSTANDING review, and every reader they need has
      // one on Me's older teams already. Like SavedArcTeam this has no members - both ARCs are
      // PUBLIC/PUBLIC, so the readers claim without joining.
      AppleCodesTeam: {
        id: this.getNextId(),
        name: 'Apple Codes Test Team',
        image: 'test.png',
        description: 'Team for the Apple Books promo code scenarios',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.Me.id
      },
      // sc-29038: team for the capped publisher's campaigns. No members, so the campaigns that go live
      // notify nobody.
      CappedPublisherTeam: {
        id: this.getNextId(),
        name: 'Capped Publisher Team',
        image: 'test.png',
        description: 'Team for the capped publisher scenario',
        defaultDisclaimer: bsConstants.ARC_TEAMS.DISCLAIMERS.FREE_VIA_BS,
        userId: seedUsers.CappedPublisher.id
      }
    }

    return testData
  }
}
